import { useState, useEffect } from 'react';

const STORAGE_KEY = 'yourbeans_bookmarks';

export interface Bookmark {
  id: string;
  type: 'module' | 'resource';
  title: string;
  addedAt: number;
}

export function useBookmarks() {
  const [bookmarks, setBookmarks] = useState<Bookmark[]>(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(bookmarks));
  }, [bookmarks]);

  const addBookmark = (id: string, type: 'module' | 'resource', title: string) => {
    setBookmarks(prev => {
      if (prev.some(b => b.id === id)) return prev;
      return [...prev, { id, type, title, addedAt: Date.now() }];
    });
  };

  const removeBookmark = (id: string) => {
    setBookmarks(prev => prev.filter(b => b.id !== id));
  };

  const isBookmarked = (id: string) => {
    return bookmarks.some(b => b.id === id);
  };

  const toggleBookmark = (id: string, type: 'module' | 'resource', title: string) => {
    if (isBookmarked(id)) {
      removeBookmark(id);
    } else {
      addBookmark(id, type, title);
    }
  };

  return {
    bookmarks,
    addBookmark,
    removeBookmark,
    isBookmarked,
    toggleBookmark
  };
}
